import FingerprintJS from '@fingerprintjs/fingerprintjs';
// import { v4 as uuidv4 } from 'uuid';
import { init, Types, track, Identify, identify } from '@amplitude/analytics-browser';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';


let eventsQueue = [];
const USER_TRACK_ID_KEY = '__userTrackId';
const GAME_TYPE = window['__game_type'] || window['__gameId'];

let userTrackId = localStorage.getItem(USER_TRACK_ID_KEY) || uuidv4();
let userIdentity: Identify;
let casinoId: string;
let isInitialized = false;

function getUrlParam(paramName) {
    return new URLSearchParams(location.search).get(paramName);
}

export async function initAnalytics() {
    if (!!(getUrlParam('disable_analytics') === 'true') || import.meta.env.VITE_IS_LOCAL_DEV === 'true') {
        console.warn('Analytics intentionally disabled on frontend');
        return;
    }

    if (isInitialized) {
        console.error('Amplitude analytics already initialized');
        return;
    }

    try {
        const durationStartLoading = dayjs();

        userIdentity = new Identify();

        addToUserIdentity({ source: getUrlParam('source'), game_type: GAME_TYPE });
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        if (result?.visitorId?.length) {
            userTrackId = result.visitorId;
        }
        identify(userIdentity);
        localStorage.setItem(USER_TRACK_ID_KEY, userTrackId);
        console.log('user t id ' + userTrackId);

        init(import.meta.env.VITE_AMPLITUDE_KEY, userTrackId, {
            logLevel: import.meta.env.DEV ? Types.LogLevel.Debug : Types.LogLevel.None
        });
        isInitialized = true;

        const duration = dayjs.duration(dayjs().diff(durationStartLoading)).asSeconds();
        console.log('analytics loading duration ' + duration);
    } catch (e) {
        console.error('Error retrieving user fingerprint:', e);
    }
}

function _trackEvent(eventName, eventProps = {}) {
    track(eventName, {
        fingerprint_id: userTrackId,
        // partner_id: getUrlParam('partnerId') || 'NFTCLAW',
        game_type: GAME_TYPE,
        casinoId: casinoId,
        ...eventProps
    });
}

function addToUserIdentity(params) {
    if (userIdentity) {
        for (const [key, value] of Object.entries(params)) {
            userIdentity.set(key, value as Types.ValidPropertyType);
        }
    }
    identify(userIdentity);
}

export async function trackEvent(eventName, eventProps = {}) {
    // If analytics not enabled yet - queue events
    if (!userTrackId) {
        eventsQueue.push({ eventName, eventProps });
        return;
    }

    // Process queued events
    if (eventsQueue && eventsQueue.length > 0) {
        for ({ eventName, eventProps } of eventsQueue) {
            _trackEvent(eventName, eventProps);
        }
        eventsQueue = [];
    }

    _trackEvent(eventName, eventProps);
}

export function getUserTrackId() {
    return userTrackId;
}

export function setCasinoId(value: string) {
    casinoId = value;
}
